// Inlined so node:test can load this file. constants.js uses extensionless
// imports that Node cannot resolve. Must match SLIDE_MENU_COLLAPSED_STORAGE_KEY.
const SLIDE_MENU_COLLAPSED_STORAGE_KEY = "bz.slideMenuCollapsed.v1";

export const getSlideMenuCollapsedFromStorage = () => {
  try {
    return localStorage.getItem(SLIDE_MENU_COLLAPSED_STORAGE_KEY) === "1";
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const setSlideMenuCollapsedInStorage = (isCollapsed) => {
  try {
    localStorage.setItem(
      SLIDE_MENU_COLLAPSED_STORAGE_KEY,
      isCollapsed ? "1" : "0"
    );
  } catch (error) {
    console.log(error);
  }
};
